<template>
  <main>
    <div class="container">
      <div class="pricing-container">
        <h1 class="heading-primary">{{$t('pricing.title')}}</h1>
        <p class="description pricing-header">{{$t('pricing.header')}}<br>
        
        <span style="font-size:1.6rem;" v-html="$t('pricing.desc')">
        </span>
        </p>
        
        <div class="billing-container" >
          <h1 class="header">Subscriptions & Passes</h1>
          <!-- <p class="details-link" @click="openFullComparison">View full comparison</p> -->
          <div class="switch-container">
              <div class='plan-container'>
                <h4 class="switch-title">Monthly</h4>
                <RadioButton v-model="selectedFrequency" value="Monthly" key="Monthly" />
              </div>
              <div class='plan-container'>
                <h4 class="switch-title">Annual</h4>
                <RadioButton v-model="selectedFrequency" value="Yearly" key="Annual" />
              </div>
          </div>
          <div class="save-container">
            <p>Get 2 months free with an annual subscription.</p>
          </div>
          <div class="subscriptions-container">
            <div class="subscription-card ">
              
              <h3 class="subscription-title" >Free</h3>
               
              <div class='subscription-description-container'>
                <p class="subscription-description">A comprehensive set of tools and data to accelerate your research process.</p>
              </div>
              <div class="price-container">
                <h1 class="price"><span>$</span>0</h1>
                <p class="currency">USD</p>
              </div>
              <p class="frequency">{{frequencyFree}}</p>
              <div class='bottom-content-container'>
                <ul class="feature-list" style="margin-bottom: 3px;margin-top:0px;">
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Full access to games and competitions<sup>1</sup></span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Social/community features</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Paper Portfolios<sup>2</sup></span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Market screener</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Watch lists</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Financials and Metrics</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Analyst Recommendations</span>
                  </li>
                   <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Charting</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">...and lots more Research tools<sup>3</sup></span>
                  </li>
                  
                   <li class="feature">
                    <span><small><sup>1</sup> Only Premium Subscribers elligible for cash prizes.</small></span>
                  </li>
                  
                  <li class="feature">
                    <span><small><sup>2</sup> Limited to 2 Trading accounts and 3 trades per day.</small></span>
                  </li>
                  <li class="feature">
                    <span><small><sup>3</sup> Limited to 10 reasearch sessions in a 30 day period.</small></span>
                  </li>
                 

                </ul>
              
               
                 <button class="cta-button upgrade" @click="goToSignup($event)">Get Started</button>
                  
            
             
                
              </div>
            </div>
            <div class="subscription-card recommended">
              
                <h3 class="subscription-title">Premium</h3>
                
              <div class='subscription-description-container'>
                <p class="subscription-description">Great for investors looking to take their research to the next level.</p>
              </div>
              <div class="price-container">
                <h1 class="price"><span>$</span>{{premiumPrice}}</h1>
                <p class="currency">USD</p>
              </div>
              <p class="frequency">{{frequency}}</p>
              <div class='bottom-content-container'>
                <ul class="feature-list" style="margin-bottom: 3px;margin-top:0px;">
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Everything in Free</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">North American company filings</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Shareholder information</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Customizable alerts</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Earnings calendar</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Dividends calendar</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Cash flow forecaster</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Unlimited Paper Portfolios</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Unlimited Research and Trading</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Level 2 Competition Trading Data</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Eligible for Contest Cash Prizes</span>
                  </li>
                  <li class="feature">
                    <i class="pi pi-check" />
                    <span class="feature-title">Enhanced Financials and Metrics</span>
                  </li>
                    
                </ul>
                
                 <button class="cta-button upgrade" @click="goToSignup($event)">Get Started</button>
                  
            
            
                
                
              </div>
            </div>
            <div class="subscription-card">
              <div class='subscription-title-container'>
                <h3 class="subscription-title">Investor Pass</h3>
                
              </div>
              <div class='subscription-description-container'>
              
                <p class="subscription-description"><span class='investor-pass-pill recommended'>Premium Investor Pass</span></p>
                <p class="subscription-description"> No usage limits and access to all premium features, including Level 2 Competition Trading Data, for the duration of the pass.</p>

                <p class="subscription-description"><span class='investor-pass-pill basic'>Basic Investor Pass</span></p>
                <p class="subscription-description">Removes Free Plan usage limits on research and trading for the duration of the pass.</p>
              
              </div>
              <!-- <div class="price-container">
                <p><strong>$1000.00 USD Playdough for 1 Day Pass</strong></p>
              </div>
              <div class="price-container">
                <p><strong>$5000.00 USD Playdough for 30 Day Pass</strong></p>
              </div> -->
              <div class='subscription-description-containers'>
              <p class="subscription-description">All Passes come in 1, 14 and 30 day durations and can be purchased using <strong>Playdough</strong>.</p>
              <p class="subscription-description"> You can buy <strong>Playdough</strong> separately or you can earn it by:</p>
              </div>
              <div >
                  <ul class="feature-list" style="padding-inline-start:unset;">
                    <li class="feature"><i class="pi pi-check" /> <span class="feature-title">Playing games like FinTrivia.</span></li>
                    <li class="feature"> <i class="pi pi-check" /><span class="feature-title">Submittting and voting on motions.</span></li>
                    <li class="feature"> <i class="pi pi-check" /><span class="feature-title">Helping others in the community.</span></li>
                    <li class="feature"> <i class="pi pi-check" /><span class="feature-title">Making good trades!</span></li>
                  </ul>
              
              </div>
                
              <div class='bottom-content-container'>
                 <button class="cta-button upgrade" @click="goToSignup($event)" >Get Started</button>
                  
            
              </div>
            </div>
        </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import "primeicons/primeicons.css";
import { SIGNUP_URL } from "../config";

import RadioButton from 'primevue/radiobutton';

export default {

  head() {
      return {
        title: "INVRS - Pricing.",
        meta:[
          { 
            name: "description",
            content: "We keep our courses and plans extremely reasonable so you have more money to grow."
          },
          { 
            name: "twitter:title",
            content: 'INVRS - Pricing.'
          },
          { 
            name: "twitter:description",
            content: "We keep our courses and plans extremely reasonable so you have more money to grow."
          },
          { 
            name: "og:title",
            content: 'INVRS - Pricing.'
          },
          { 
            name: "og:description",
            content: "We keep our courses and plans extremely reasonable so you have more money to grow."
          },
        ]
      }
    },

  data() {
    return {
      annual:false,
      isLoggedIn: false,

      currentPlan: 1,
      premium:false,
      selectedFrequency: 'Monthly',
    };
  },

  components:{
    RadioButton
  },

  computed: {
   

    
    premiumPrice() {
      if (this.selectedFrequency === 'Yearly') {
        return "99.50";
      } else {
        return "9.95";
      }
    },

    

    frequency() {
      if (this.selectedFrequency === 'Yearly') {
        return 'per year (2 months free with annual billing)';
      } else {
        return 'per month';
      }
    },

    frequencyFree() {
      if (this.selectedFrequency === 'Yearly') {
        return 'per year';
      } else {
        return 'per month';
      }
    },

    premiumPortfolioFrequency() {
      if (this.selectedFrequency === 'Yearly') {
        return 'per year';
      } else {
        return 'per month';
      }
    }
  },

  mounted() {
    if (this.$route.query.loggedIn) {
      this.isLoggedIn = true;
    }
  },

  methods: {
    isMobile() {
      let check = false;

      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);//eslint-disable-line
    
      return check;
    },

    monthlyHandler() {
      this.annual = false;
    },

    basicHandler() {
      this.premium = false;
    },


    annualHandler() {
      this.annual = true;
    },

    premiumHandler() {
      this.premium = true;
    },

    currentPlanHandler(num) {
      this.currentPlan = num;
    },

    goToSignup(evt) {
      evt.preventDefault();
      window.location.href = SIGNUP_URL
      
    },

    
  },
};
</script>

<style scoped>

.toggle .tb {
  padding: .5rem 1rem;
  font-size: 16px !important;

}

.toggle .tb:hover:not(.selected) {
  color: #333;
  background-color: #d1d2d3;
}
.toggle .selected.tb:hover  {
  color: #333;
}

.pricing-container {
  padding: 13rem 12rem;
}

.description {
  /* margin-bottom: 6.4rem; */
  line-height: 3.5rem;
}

.spacer {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: end;
  justify-self: start;
  min-height:44px;
}


.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: end;
  justify-self: start;
  
}

.toggle h4 {
  font-size: 1.8rem;
  font-weight: 400;
  margin-right: 0.8rem;
}

.toggle h4:last-child {
  margin-left: 0.8rem;
  margin-right: 0;
}

.pricing-grid,
.grid-header {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2rem;
}

.grid-subheader,
.grid-header {
  grid-column: 1 / 5;
}

.plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.plan h3 {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  text-align: center;
}

.pricing-grid .plan p {
  font-size: 2.4rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  color: #999;
}

.plan button {
  padding: 1.2rem 2.4rem;
  border-radius: 8px;
  border: 1px solid #693bf5;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  font-size: 1.6rem;
  font-family: inherit;
}

.plan button:hover {
  background-color: #693bf5;
  color: #fff;
}

.grid-subheader {
  padding-top: 2.4rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #d1d2d3;
}

.grid-subheader h2 {
  font-size: 2.8rem;
  font-weight: 500;
  color: #333;
}

.pricing-grid p {
  font-size: 1.6rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 1.2rem;
  align-self: center;
  line-height: 1.2;
}

.pi-check,
.pi-times {
  font-size: 2.4rem;
  color: #3c9;
  align-self: center;
  justify-self: center;
}

.pi-times {
  color: #d1d2d3;
}

.toggle {
  background-color: #d1d2d3;
  padding: 0.6rem;
  border-radius: 8px;
}

.toggle button {
  margin-right: 8px;
  padding: 1rem 2rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background-color: transparent;
}

.toggle button:last-child {
  margin-right: 0;
}

.toggle button.selected {
  background-color: #f2f4fa;
}

.pricing-grid .free__direct-messaging {
  text-align: center;
  margin-bottom: 0px;
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .heading-primary {
    font-size: 6rem;
  }
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  .heading-primary {
    font-size: 5.6rem;
  }
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .pricing-container {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .pricing-container {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }

  .heading-primary {
    font-size: 5rem;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
  }

  .pricing-grid .free__direct-messaging {
    grid-column: auto;
    text-align: right;
    margin-bottom: 1.2rem;
  }

  .pi-check,
  .pi-times {
    text-align: right;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  .heading-primary {
    font-size: 4.4rem;
    text-align: center;
    line-height: 1.2;
  }

  .description {
    text-align: center;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }

  .toggle {
    grid-column: 1 / 3;
    justify-self: center;
    margin-bottom: 2.4rem;
  }

  .pricing-grid p {
    grid-column: 1 / 4;
    font-size: 1.8rem;
  }

  .grid-subheader {
    margin-top: 3.2rem;
    margin-bottom: 1.6rem;
  }

  .pi-check,
  .pi-times {
    /* width: 100%; */
    justify-self: center;
    margin-bottom: 1.6rem;
  }

  .pi-check.last {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .pricing-grid .plan p {
    font-size: 2.2rem;
  }
}

/* **************************** */
/* BELOW 432px (mobile) */
/* **************************** */
@media (max-width: 27em) {
  .pricing-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

/*************************************************************** */
/** new pricing styles */

.free-bottom-content-container{
  margin-top: 1rem;
}
.pi {
  font-size:1rem;
}

.pass-row{
  padding: 5px;
}

.pass-desc-header{
  font-weight: bold;
  margin-right: auto;
  font-size: 16px;
}

.pass-expiry-header{
  float:right;
  margin-left: 10px;
  font-weight: bold;
}

.pass-desc{
  
  margin-right: auto;
  font-size: 14px;
}

.pass-expiry{
  float:right;
  margin-left: 10px;
  font-size: 14px;
  
}


.billing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px 0px;
  font-family: 'Trebuchet MS';
  font-size: 14px;
}

.header {
  font-size: 24px;
  color: #32364e;
  text-align: center;
  margin-bottom: 14px;
}

.details-link {
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 26px;
}

.details-link:hover {
  color: #3c9;
}

.switch-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.switch-title {
  margin: 0 16px 0 0;
  font-size: 18px;
  font-weight: bold;
  color: #32364e;
}

.plan-container {
  display: flex;
  margin-right: 16px;
}
.plan-container:last-child {
  margin-right: 0px;
}

.save-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 36px;
  padding: 10px 30px;
  border: 1px solid #3c9;
  border-radius: 8px;
  background-color: rgba(51, 204, 153, 0.427);
  color: #32364e;
  font-size: 14px;
}

.subscriptions-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.subscription-card {
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  margin-right: 24px;
  width: 350px;
  height: 55rem;
}

.subscription-card.recommended {
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
  border: 1px solid #3c9;
}

.subscription-card:last-child {
  margin-right: 0px;
}

.subscription-title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
}
.subscription-title-container .subscription-title {
  margin-bottom: 4px;
}

.subscription-title {
  color: #32364e;
  text-align: center;
}

/* .subscription-title span {
  padding: 4px 8px;
  background-color: #693BF5;
  color: #fff;
  border-radius: 500px;
  font-size: 10px;
  text-transform: uppercase;
  position: absolute;
  transform: translate(8%, 8%);
} */

.subscription-pill-row {
  display: flex;
}

.subscription-pill {
  padding: 4px 8px;
  margin-right: 4px;
  color: #fff;
  border-radius: 500px;
  font-size: 10px;
  text-transform: uppercase;
}

.investor-pass-pill {
  padding: 4px 8px;
  margin-right: 4px;
  color: #fff;
  border-radius: 500px;
  font-size: 12px;
  text-transform: uppercase;
}

.investor-pass-pill.basic {
  background-color: #3c9;

}
.investor-pass-pill.recommended {
  background-color: #693BF5;

}
.subscription-pill:last-child {
  margin-right: 0;
}
.subscription-pill.recommended {
  background-color: #693BF5;
}
.subscription-pill.current {
  background-color: #32364e;
}
.subscription-pill.trial-expired {
  background-color: #e63e3e;
}

.subscription-description-container {
  color: black;
  text-align: center;
  margin-bottom: 16px;
}
.subscription-description-container p {
  margin-bottom: 0;
}

.price-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.price {
  margin: 0;
  margin-right: 6px;
  color: #32364e;
  line-height: 1;
}

.price span {
  font-size: 16px;
  position: absolute;
  transform: translate(-100%, 50%);
}

.frequency {
  color: #999;
  text-align: center;
  margin-bottom: 24px;
}

.feature-list {
  list-style: none;
  margin-bottom: 24px;
}
.feature-list:last-child {
  margin-bottom: 0px;
}

.pi-check {
  color: #3c9;
  margin-right: 8px;
  margin-bottom: 12px;
}

.cta-button {
  width: 100%;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #3c9;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
  font-size: 16px;
}

.cta-button:hover {
  opacity: 0.9;
}

.manage {
  background-color: #32364e;
}

.downgrade {
  background-color: #e63e3e;
}

.upgrade {
  background-color: #3c9;
}

.trial-text {
  color: #999;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  text-decoration: underline;
  cursor: pointer;
}

.trial-text:hover {
  color: #3c9;
}

.bottom-content-container {
  margin-top: auto;
}

@media (max-width: 1224px) {
 .subscription-card {
    height: 59rem;
 }

 .feature-list {
  padding-left: 20px;
 }
}

@media (max-width: 1136px) {
 .subscription-card {
    height: 65rem;
    width: 315px;
 }


}

@media (max-width: 760px) {
  
  .subscriptions-container {
    display: block;
    margin-bottom:30px;
    
  }

  .subscription-card {
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 0px;
     height: 68rem;
     width: 315px;
  
   padding: 10px 14px;
  }

  .subscription-title {
    font-size:1.17em;
  }
}

.subscription-description{
  margin-top:8px;
}

 .heading-primary {
    font-size: 4rem;
    text-align: center;
  }

  sup{
    font-size:x-small;
  }

  .pricing-header{
    text-align: center;
  }
</style>
